import { TCardDefaults } from '../../../../types/partner-page-types';

interface IPlanIcon {
  planId: string;
  card_defaults: TCardDefaults;
}

export const PlanIcon: React.FC<IPlanIcon> = ({ planId, card_defaults }) => {
  const icon = card_defaults[planId]?.image;
  if (!icon) return <></>;
  return (
    <div className="absolute top-0 right-0">
      <img
        alt="plan-icon"
        src={card_defaults[planId]?.image}
        height={116}
        width={128}
        className="w-32 h-[116px] object-scale-down"
      ></img>
    </div>
  );
};
